import { render } from "./SuccessErr.vue?vue&type=template&id=5c535473"
import script from "./SuccessErr.vue?vue&type=script&lang=js"
export * from "./SuccessErr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__